import { useState, useEffect } from "react";
import { getArticlesByTypeWidget } from "../api/widgets/articlesByType/requests";

function useStoryblokArticlesByTypeWidget(types) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getArticlesByTypeWidget(Array.isArray(types) ? types.join(',') : types)
      .then((data) => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .then(() => setIsLoading(false));
  }, []);

  return [data, isLoading];
}

export { useStoryblokArticlesByTypeWidget };
